export default __webpack_public_path__ + "static/media/Singapore.e4b110e4.svg";